import React from 'react';
import { CircleCheckIcon, GlobeIcon, LockIcon } from 'lucide-react';
import { CtaButton } from '../CtaButton';
import { Countdown } from '../Countdown';
import { ScarcityBar } from '../ScarcityBar';
import { images } from '../../data/content';
const stack = [{
  title: 'Picking Control 30™',
  detail: '6 premium volumes',
  value: 97
}, {
  title: '5 exclusive bonuses',
  detail: 'Error Hunter, Diagnostic, Calculator, Daily Control, 30 Checklists',
  value: 147
}];
const perks = ['One-time payment', 'Lifetime access', 'No monthly fees', 'Instant digital access'];
export function Offer() {
  return <section id="offer" className="bg-cream px-4 py-16 sm:py-20" aria-labelledby="offer-title" data-id="element-162" data-mp="3jv071n478ehb">
      <div className="mx-auto max-w-xl" data-id="element-163" data-mp="3nx3l8ji95x6a">
        <p className="text-center text-sm font-extrabold uppercase tracking-wider text-danger" data-id="element-164" data-mp="3nw25w2u7eoir">Special launch offer</p>
        <h2 id="offer-title" className="mt-2 text-center font-serif text-[32px] font-black leading-tight text-ink sm:text-5xl" data-id="element-165" data-mp="3su3qis7a2vwc">
          Here’s everything you’ll get today
        </h2>

        <div className="mt-8 overflow-hidden rounded-3xl bg-white shadow-[0_20px_50px_rgba(11,27,46,0.15)] ring-4 ring-gold" data-id="element-166" data-mp="1kjdn3cjlrd42">
          <img src={images.mockup} alt="Everything included in Picking Control 30™" className="w-full bg-cream" data-id="element-167" data-mp="1bkifbw0wtuyn" />
          <div className="p-5 sm:p-8" data-id="element-168" data-mp="16m8mvt6kl8gq">
            <ul className="divide-y divide-ink/10" data-id="element-169" data-mp="16n9z40zbo101">
              {stack.map(s => <li key={s.title} className="flex items-start justify-between gap-4 py-4" data-id="element-170" data-mp="23aodlslf1nvf">
                  <div data-id="element-171" data-mp="1zbnvkcarip9h">
                    <p className="text-lg font-extrabold text-ink" data-id="element-172" data-mp="1zb5yxek6u911">{s.title}</p>
                    <p className="text-sm text-muted" data-id="element-173" data-mp="1uicukrsmt2ph">{s.detail}</p>
                  </div>
                  <p className="shrink-0 text-lg font-bold text-muted line-through decoration-danger decoration-2" data-id="element-174" data-mp="1pjrvivp48p2m">${s.value}</p>
                </li>)}
              <li className="flex items-center justify-between gap-4 py-4" data-id="element-175" data-mp="2i9ib796ebz0u">
                <p className="text-sm font-bold uppercase tracking-wider text-ink" data-id="element-176" data-mp="2i7dwdw6ylfls">Total perceived value</p>
                <p className="text-2xl font-black text-danger line-through decoration-2" data-id="element-177" data-mp="364kapth5lu3l">$244</p>
              </li>
            </ul>

            <div className="mt-2 rounded-2xl bg-ink p-6 text-center" data-id="element-178" data-mp="2sdypvz853a32">
              <p className="text-sm font-semibold uppercase tracking-wider text-white/75" data-id="element-179" data-mp="2weqxko1d56x8">Today you can get everything for just</p>
              <p className="mt-1 font-serif text-[88px] font-black leading-none text-gold" data-id="element-180" data-mp="2idy486msshvp">
                <span className="align-top text-4xl" data-id="element-181" data-mp="2neccnpsb9tu9">$</span>27
              </p>
              <p className="mt-1 text-sm font-semibold text-white" data-id="element-182" data-mp="29ekt79j0zl8v">USD · one-time payment</p>
              <ul className="mt-5 grid grid-cols-2 gap-2 text-left" data-id="element-183" data-mp="2dfmtzuslc5cy">
                {perks.map(p => <li key={p} className="flex items-center gap-2 text-sm font-medium text-white" data-id="element-184" data-mp="7n7rsug9nvhk">
                    <CircleCheckIcon className="h-4 w-4 shrink-0 text-gold" aria-hidden="true" data-id="element-185" data-mp="bo9u5k5hcnnr" />
                    {p}
                  </li>)}
              </ul>
            </div>

            <div className="mt-6 flex items-start gap-3 rounded-xl bg-gold-soft p-3 text-[14px] font-medium leading-snug text-ink" data-id="element-186" data-mp="1s58srlmykio4">
              <GlobeIcon className="mt-0.5 h-5 w-5 shrink-0" aria-hidden="true" data-id="element-187" data-mp="25x5hdfpf4afr" />
              <span data-id="element-188" data-mp="215f0eqvz6ofd">
                <strong data-id="element-189" data-mp="214vktgtssc4i">Automatic currency conversion:</strong> the price is shown and charged in your local currency
                based on your location.
              </span>
            </div>

            <div className="mt-5" data-id="element-190" data-mp="2auosw7uqe940">
              <ScarcityBar data-id="element-191" data-mp="2axt61uq6cf6t" />
            </div>

            <div className="mt-6" data-id="element-192" data-mp="2ovho6usux886">
              <CtaButton label="Get Picking Control 30™" data-id="element-193" data-mp="2ougeatnkurs1" />
              <p className="mt-3 flex items-center justify-center gap-1.5 text-center text-sm text-muted" data-id="element-194" data-mp="2jvwt4vgt5k0q">
                <LockIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-195" data-mp="ui9q8u9l4gib" />
                One-time payment of $27 · Instant access · 7-day guarantee
              </p>
            </div>

            <div className="mt-8" data-id="element-196" data-mp="rxbsnhaxp2e4">
              <Countdown data-id="element-197" data-mp="rw91r9dm2zy7" />
            </div>
          </div>
        </div>

        <p className="mx-auto mt-6 text-center text-[16px] leading-relaxed text-ink/80" data-id="element-198" data-mp="vxm8rmsfx96p">
          For just $27, you’ll get a complete framework for diagnosing, controlling and improving your picking operation
          over the next 30 days.
        </p>
      </div>
    </section>;
}